import {Box, BoxProps, Heading, Text, TextProps} from '@chakra-ui/react'
import {ReactNode} from 'react'

interface Props extends BoxProps {
  label?: ReactNode
  description?: ReactNode
  variant?: 'default' | 'card'
  /**
   * @default vertical
   */
  orientation?: 'vertical' | 'horizontal'
  contentProps?: BoxProps
  labelProps?: TextProps
}

export function FormSection({
  children,
  label,
  description,
  variant,
  orientation = 'vertical',
  contentProps,
  labelProps,
  ...props
}: Props) {
  const isCard = variant === 'card'
  let boxProps: BoxProps = {}

  if (isCard) {
    boxProps = {
      ...boxProps,
      padding: '5',
      backgroundColor: 'bg.subtle',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'border',
      borderRadius: 'l3',
    }
  }

  if (orientation === 'horizontal') {
    boxProps = {
      ...boxProps,
      display: 'grid',
      gridTemplateColumns: '45% 55%',
      gapX: '5',
    }
  } else {
    boxProps = {
      ...boxProps,
      spaceY: '5',
    }
  }

  return (
    <Box as="section" {...boxProps} {...props}>
      {(label || description) && (
        <Box>
          {label && (
            <Heading as="h2" fontSize="md" {...labelProps}>
              {label}
            </Heading>
          )}
          {description && (
            <Text fontSize="sm" color="fg.muted">
              {description}
            </Text>
          )}
        </Box>
      )}

      <Box spaceY="4" {...contentProps}>
        {children}
      </Box>
    </Box>
  )
}
